// extracted by mini-css-extract-plugin
module.exports = {"logoMarkWrapper":"logo_logoMarkWrapper__3NhBf","logoMark":"logo_logoMark__aLyMF","logoWrapper":"logo_logoWrapper__2GQpD"};